class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);

        if (!this.classList.contains('is-empty')) {
          setTimeout(() => {
            const recommendationsElement = this.querySelector('product-recommendations[data-cart-recommendations="true"]');
            if (recommendationsElement) {
              if (typeof recommendationsElement.loadCartRecommendations === 'function') {
                recommendationsElement.loadCartRecommendations();
              } else {
                const parent = recommendationsElement.parentNode;
                const nextSibling = recommendationsElement.nextSibling;
                parent.removeChild(recommendationsElement);
                parent.insertBefore(recommendationsElement, nextSibling);
              }
            }
          }, 100);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      this.reloadCartRecommendations();
    });
  }

  reloadCartRecommendations() {
    setTimeout(() => {
      const recommendationsElement = this.querySelector('product-recommendations[data-cart-recommendations="true"]');
      if (!recommendationsElement) return;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (!cart.items || cart.items.length === 0) {
            const recommendationsContainer = recommendationsElement.closest('.cart-drawer__recommendations');
            if (recommendationsContainer) {
              recommendationsContainer.style.display = 'none';
            }
            return;
          }

          const firstProductId = cart.items[0].product_id;

          recommendationsElement.dataset.productId = firstProductId;

          const baseUrl = window.routes?.product_recommendations_url || '/recommendations/products';
          const newUrl = `${baseUrl}?limit=6&section_id=cart-drawer-recommendations&product_id=${firstProductId}`;
          recommendationsElement.dataset.url = newUrl;

          recommendationsElement.classList.remove('product-recommendations--loaded');
          const slider = recommendationsElement.querySelector('.cart-drawer__recommendations-slider');
          if (slider) {
            slider.innerHTML = '';
          }

          if (typeof recommendationsElement.initializeRecommendations === 'function') {
            recommendationsElement.initializeRecommendations(firstProductId);
          }
        })
        .catch(err => {});
    }, 300);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
